import { render, staticRenderFns } from "./ProductCheckedBlock.vue?vue&type=template&id=869e359a&scoped=true"
import script from "./ProductCheckedBlock.vue?vue&type=script&lang=js"
export * from "./ProductCheckedBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869e359a",
  null
  
)

export default component.exports